import { atom, useAtom, useAtomValue } from "jotai";

const visibilityAtom = atom(false);

export default function usePinUnlockVisibility() {
  return useAtom(visibilityAtom);
}

export function usePinUnlockVisibilityValue() {
  return useAtomValue(visibilityAtom);
}
